// UnpublishedPostCard.js
'use strict';
import { connect } from 'react-redux';

import { SHORT_VIDEO_DURATION_SECONDS } from '../RemoteConfigKeys.js';

import UnpublishedPostCard from '../component/UnpublishedPostCard.jsx';

import getMessageDataWithVariable, {
  VariableName,
} from '../selector/getMessageDataWithVariable.js';
import getMeData from '../selector/getMeData.js';
import getMessageData from '../selector/getMessageData.js';
import getAssetData from '../selector/getAssetData.js';
import getRemoteConfigData from '../selector/getRemoteConfigData.js';

import subscribePresenceMessage from '../action/subscribePresenceMessage.js';

const mapStateToProps = (state, { messageId }) => {
  const meUsername = getMeData(state, 'username');
  const assetIds = getMessageData(state, messageId, 'assetIds') || [];
  const assetId = assetIds[0];
  return {
    messageId,
    meId: getMeData(state, 'id'),
    senderId: getMessageData(state, messageId, 'senderId'),
    originalTitle: getMessageDataWithVariable(
      state,
      messageId,
      'originalTitle',
      `${VariableName.USERNAME}:${meUsername}`
    ),
    originalCaption: getMessageDataWithVariable(
      state,
      messageId,
      'originalCaptionText',
      `${VariableName.USERNAME}:${meUsername}`
    ),
    contentType: getAssetData(state, [assetId], 'contentType'),
    duration: getAssetData(state, [assetId], 'duration'),
    createdAtUnix: getMessageData(state, messageId, 'createdAtUnix'),
    postedAtUnix: getMessageData(state, messageId, 'postedAtUnix'),
    ttl: getMessageData(state, messageId, 'ttl'),
    scheduledAtUnix: getMessageData(state, messageId, 'scheduledAtUnix'),
    shortVideoDuration: getRemoteConfigData(
      state,
      SHORT_VIDEO_DURATION_SECONDS
    ),
  };
};

const mapDispatchToProps = dispatch => {
  return {
    subscribePresenceMessage: data => dispatch(subscribePresenceMessage(data)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(UnpublishedPostCard);
